import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";

export const CallbackPage = ({ auth }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = () => {
      // Check for error in query params
      const errorParam = searchParams.get("error");
      if (errorParam) {
        setError(errorParam);
        toast.error("Nie udało się połączyć ze Spotify");
        setTimeout(() => navigate("/"), 2000);
        return;
      }

      // Parse token from URL hash (redirected from backend)
      const hash = window.location.hash.substring(1);
      const params = new URLSearchParams(hash);

      const accessToken = params.get("access_token");
      const refreshToken = params.get("refresh_token");
      const userJson = params.get("user");

      if (accessToken && userJson) {
        try {
          const user = JSON.parse(decodeURIComponent(userJson));
          auth.login(accessToken, user);

          if (refreshToken) {
            localStorage.setItem('spotify_refresh_token', refreshToken);
          }

          toast.success("Połączono ze Spotify!");
          navigate("/dashboard");
        } catch (err) {
          console.error("Parse error:", err);
          setError("Błąd parsowania danych");
          setTimeout(() => navigate("/"), 2000);
        }
      } else {
        setError("Brak tokenu w odpowiedzi");
        setTimeout(() => navigate("/"), 2000);
      }
    };

    handleCallback();
  }, [searchParams, navigate, auth]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-[#0A0A0A]"
      data-testid="callback-page"
    >
      {error ? (
        <div className="text-center">
          <div className="text-[#FF3366] text-xl mb-2">{error}</div>
          <p className="text-[#A1A1AA]">Przekierowuję...</p>
        </div>
      ) : (
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#FF3366] border-t-transparent rounded-full animate-spin mb-6" />
          <p className="text-[#FAFAFA] text-lg">Łączenie ze Spotify...</p>
          <p className="text-[#A1A1AA] text-sm mt-2">Proszę czekać</p>
        </div>
      )}
    </div>
  );
};
